import { AgGridReact } from "ag-grid-react";
import Select from "react-select";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "ag-grid-community/styles/ag-theme-quartz.css";
import CustomFormRenderComp from "../field/CustomFormRenderComp";
import { auto } from "@popperjs/core";
import {
  agGridOptionsNone,
  agGridTheme,
  HOST_URL,
} from "../../helpers/constants/Constants";
import axios from "axios";
import { getAllChecklists } from "../../helpers/axios/checklistsAxios";
import {
  addProjectChecklists,
  getProjectChecklists,
} from "../../helpers/axios/projectsAxios";
import {
  SELECTED_CHECKLIST,
  updateGlobalState,
} from "../../helpers/reducers/GlobalReducer";
import { set } from "lodash";
import { LoadProjectData } from "../../helpers/actions/RequestData";
import LoadingScreen from "../loadingScreen/LoadingScreen";
const Checklists = () => {
  const {
    pendingChecklistsData,
    selectedProject,
    selectedChecklist,
    allDocs,
    cloudFiles,

    totalGlobalModels,
    numberOfLoadedGlobalModels,
  } = useSelector((state) => state.globalReducer);
  const { modelData, modelDataProjectId, modelDataLoaded } = useSelector(
    (state) => state.modelReducer,
  );
  const [projectChecklistsData, setProjectChecklistsData] = useState(null);
  const userData = useSelector((state) => state.userData);
  const [gridData, setGridData] = useState(null);
  const dispatch = useDispatch();

  // const [selectedChecklist, setSelectedChecklist] = useState(null);
  const [selectedChecklistDataLink, setSelectedChecklistDataLink] =
    useState(null);

  const [addChecklist, setAddChecklist] = useState(null);
  const [allChecklists, setAllChecklists] = useState(null);
  const [viewMode, setViewMode] = useState(false);
  const [addMode, setAddMode] = useState(false);
  const [gridApi, setGridApi] = useState(null);

  const [filterModel, setFilterModel] = useState(null);
  const [sortModel, setSortModel] = useState(null);

  const [selectedRows, setSelectedRows] = useState([]);

  useEffect(() => {
    if (allDocs?.length > 0 && cloudFiles?.length > 0) {
      LoadProjectData(
        dispatch,
        selectedProject,
        allDocs,
        cloudFiles,
        modelDataProjectId,
        modelData,
      );
    }
  }, [allDocs, cloudFiles]);

  useEffect(() => {}, [gridApi]);

  useEffect(() => {
    (async () => {
      if (pendingChecklistsData != null) {
        let checklists = await getAllChecklists();
        //set ITP to false for all checklists
        await checklists.forEach((checklist) => {
          checklist.ITP = false;
        });
        setAllChecklists(checklists);
        let projectData = await getProjectChecklists(
          selectedProject[0].mviewProjectInfo.id,
        );
        setGridData([...pendingChecklistsData, ...projectData]);
      }
    })();
  }, [pendingChecklistsData]);

  //use effect for selectedChecklist to set the selectedChecklistDataLink
  useEffect(() => {
    if (selectedChecklist != null && selectedChecklistDataLink == null) {
      setSelectedChecklistDataLink(selectedChecklist.dataLinks?.[0]);
    }
  }, [selectedChecklist]);

  const recordSelectedChecklists = (grouped) => {
    //filter the selectedRows to get all the unique checklists Ids
    let uniqueChecklists = [...new Set(selectedRows.map((o) => o.checklistId))];
    //Check if all the selected checklists are the same
    if (uniqueChecklists.length > 1) {
      alert("Please select the same checklists in order to group record.");
      return;
    }
    //Check all the checklists are pending if grouped is true
    if (grouped && selectedRows.length < 1) {
      let allPending = selectedRows.every((row) => row.status === "Pending");
      if (!allPending) {
        alert(
          "Please select checklists that are in 'Pending' status to record.",
        );
        return;
      }
    }

    let checklistData = selectedRows[0];
    let dataLinks = selectedRows.map((o) => o.dataLinks).flat();
    dispatch(
      updateGlobalState({
        value: {
          ...checklistData,
          dataLinks: dataLinks,
        },
        stateName: SELECTED_CHECKLIST,
      }),
    );

    setSelectedChecklistDataLink(dataLinks);
    setViewMode(checklistData.status === "Complete");
    setAddMode(false);
  };

  const selectChecklistButton = () => {
    return (
      <div className="d-flex justify-content-between align-items-center w-100">
        <div className="d-flex">
          <button
            disabled={!selectedRows || selectedRows.length !== 1}
            className="btn btn-primary btn-sm"
            onClick={() => recordSelectedChecklists(false)}
          >
            View/Record
          </button>
          <button
            disabled={!selectedRows || selectedRows.length <= 1}
            className="btn btn-primary btn-sm"
            onClick={() => recordSelectedChecklists(true)}
          >
            Group Record
          </button>
        </div>
        <div className="d-flex align-items-center">
          <select
            className="form-select form-select-sm"
            style={{ minWidth: 400 }}
            onChange={(e) => {
              setAddChecklist(
                allChecklists?.find((o) => o.id == e.target.value),
              );
            }}
          >
            <option value="">Select Checklist</option>
            {allChecklists?.map((checklist) => (
              <option key={checklist.id} value={checklist.id}>
                {checklist.name}
              </option>
            ))}
          </select>
          <button
            className="btn btn-success btn-sm"
            disabled={!addChecklist}
            onClick={() => {
              addProjectChecklists(
                selectedProject[0].mviewProjectInfo.id,
                addChecklist.id,
                userData.data.emailId,
              );
            }}
          >
            Add
          </button>
        </div>
      </div>
    );
  };
  //----------------------

  // const pendingGridColumns = [{ field: "id", cellRenderer: recordButton, width: 50, minWidth: 50 }, { field: "name" }, { field: "category" }, { field: "tag" }];

  const recordedGridColumns = [
    // { field: "id", cellRenderer: selectChecklistButton, width: 50, minWidth: 100, maxWidth: 100 },
    {
      field: "checklist",
      width: 50,
      minWidth: 400,
      valueGetter: function (params) {
        return params.data.name;
      },
    },
    {
      field: "Origin",
      valueGetter: function (params) {
        return params.data.ITP ? "ITR" : "Manual";
      },
      minWidth: 150,
      maxWidth: 150,
    },
    {
      field: "tags",
      valueGetter: function (params) {
        var tags = params.data.dataLinks?.map((o) => {
          if (o.projectObjectId != null) {
            return modelData?.find(
              (m) => m.projectObjectId == o.projectObjectId,
            )?.tag;
          }
        });
        return tags?.join(", ");
      },
      minWidth: 150,
      maxWidth: 200,
    },
    {
      field: "Category",
      valueGetter: function (params) {
        return params.data.category;
      },
      minWidth: 150,
      maxWidth: 200,
    },
    {
      field: "name",
      width: 50,
      minWidth: 500,
      valueGetter: function (params) {
        return params.data.projectObjectId == null
          ? ""
          : modelData?.find(
              (o) => o.projectObjectId == params.data.projectObjectId,
            )?.name;
      },
    },
    { field: "status", minWidth: 150 },
    { field: "createdBy", minWidth: 150 },
    {
      field: "createdDate",
      minWidth: 150,
      valueFormatter: (params) => {
        if (params.value == null) return "";
        const date = new Date(params.value);
        return date.toLocaleDateString("en-UK", {
          year: "numeric",
          month: "numeric",
          day: "numeric",
        });
      },
    },
  ];

  const updateChecklist = (status) => {
    selectedChecklist.projectId = selectedProject[0].mviewProjectInfo.id;
    selectedChecklist.status = status;
    var formData = new FormData();
    const data = {
      checklist: selectedChecklist,
      email: userData.data.emailId,
      createdDate: new Date(),
    };
    formData.append("formData", JSON.stringify(data));
    axios({
      method: "post",
      url: HOST_URL + "/checklists/record",
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
      },
      withCredentials: true,
    })
      .then(async (response) => {
        //reload the projectChecklistsData
        setProjectChecklistsData(
          await getProjectChecklists(selectedProject[0].mviewProjectInfo.id),
        );
        //find the newly created checklist and set it as selectedChecklist
        let tempModelData = modelData?.find(
          (o) => o.projectObjectId == response.data.projectObjectId,
        );
        // setSelectedChecklist({
        //   ...response.data,
        //   projectObjectId: tempModelData.projectObjectId,
        //   projectObject: tempModelData,
        // });

        dispatch(
          updateGlobalState({
            value: {
              ...response.data,
              projectObjectId: tempModelData.projectObjectId,
              projectObject: tempModelData,
            },
            stateName: SELECTED_CHECKLIST,
          }),
        );

        setSelectedChecklistDataLink(response.data.dataLinks?.[0]);
        setViewMode(true);
        setAddMode(false);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const gridRef = useRef(null);

  return (
    <>
      {!modelDataLoaded && (
        <LoadingScreen
          input="Fetching Project Data"
          position="fixed"
          width="20"
          marginTop="3%"
          showModelLoadProgress={true}
          numberOfLoadedGlobalModels={numberOfLoadedGlobalModels}
          totalGlobalModels={totalGlobalModels.length}
        />
      )}
      <div
        className="pt-1"
        style={{
          paddingLeft: "65px",
          paddingRight: "0px",
          height: "90vh",
          overflowY: auto,
        }}
      >
        {
          //select drop down for all checklists to add manually
          !viewMode && selectedChecklist == null && (
            <>
              {/* Row of buttons to view and record with the selected checklist */}
              <div className="d-flex mb-2">{selectChecklistButton()}</div>
            </>
          )
        }
        {selectedChecklist == null && (
          <div id="gridStyle" style={{ height: "70VH" }}>
            {/* <div id="gridStyle" className="ag-theme-quartz-dark" style={{ height: "70VH" }}> */}
            <AgGridReact
              theme={agGridTheme}
              ref={gridRef}
              rowData={gridData}
              columnDefs={recordedGridColumns}
              defaultColDef={{
                editable: false,
                // flex: 1,
                minWidth: 10,
                sortable: true,
                width: 10,
                filter: "agSetColumnFilter",
              }}
              cellSelection={{
                mode: "multiRow",
                handle: {
                  mode: "fill",
                  direction: "y", // Fill Handle can only be dragged horizontally
                },
              }}
              onGridReady={(params) => {
                // if (filterModel) {
                //   params.api.setFilterModel(filterModel);
                // }
                // if (sortModel) {
                //   params.api.setSortModel(sortModel);
                // }
                setGridApi(params.api);
              }}
              // onFilterChanged={(e) => {
              //   setFilterModel(e.api.getFilterModel());
              // }}
              // onSortChanged={(e) => {
              //   setSortModel(e.api.getSortModel());
              // }}
              // onSelectionChanged={(e) => {
              //   setSelectedRows(e.api.getSelectedRows());
              // }}
              // reactiveCustomComponents={false}
              gridOptions={agGridOptionsNone}
            />
          </div>
        )}
        {selectedChecklist != null && (
          <>
            <button
              className="btn btn-primary btn-sm mb-2"
              onClick={(e) => {
                dispatch(
                  updateGlobalState({
                    value: null,
                    stateName: SELECTED_CHECKLIST,
                  }),
                );
                setAddMode(false);
                setViewMode(false);
                setSelectedChecklistDataLink(null);
                setSelectedRows([]);
                if (gridApi) {
                  gridApi.deselectAll();
                }
              }}
            >
              Back
            </button>
            {!viewMode && (
              <>
                <button
                  className="btn btn-warning btn-sm mb-2"
                  onClick={(e) => updateChecklist("In Progress")}
                >
                  Save as In Progress
                </button>
                <button
                  className="btn btn-success btn-sm mb-2"
                  onClick={(e) => updateChecklist("Complete")}
                >
                  Complete
                </button>
              </>
            )}
            <div className="mt-2 d-flex justify-content-center">
              <div className="col-8">
                <h3>General Properties</h3>
              </div>
            </div>

            {
              //If not viewmode and selectedChecklist has no projectObject
              !viewMode && addMode && false && (
                <>
                  <div className="mt-2 d-flex justify-content-center">
                    <div className="col-4">
                      <Select
                        isMulti
                        name="roles"
                        options={modelData
                          .filter((o) => o.tag != null && o.tag !== "")
                          .map((o) => ({ value: o.tag, label: o.tag }))}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        onChange={(e) => {
                          //if modelData contains a projectObjectId then create a dataLink object with the projectObjectId

                          let newDataLinks = e.map((o) => {
                            var tempModelData = modelData?.find(
                              (d) => d.tag == o.value,
                            );
                            return {
                              projectObjectId: tempModelData.projectObjectId,
                              projectObject: tempModelData,
                              tag: tempModelData.tag,
                            };
                          });

                          dispatch(
                            updateGlobalState({
                              value: {
                                ...selectedChecklist,
                                dataLinks: newDataLinks,
                              },
                              stateName: SELECTED_CHECKLIST,
                            }),
                          );
                        }}
                      />
                      {/* <select
                        className="form-select form-select-sm "
                        onChange={(e) => {
                          let tempModelData = modelData.find((o) => o.tag == e.target.value);
                          //create a dataLink and if its not already assigned to the checklist then add it

                          
                          dispatch(
                          updateGlobalState({
                            value: {
                                ...selectedChecklist,
                                projectObjectId: tempModelData.projectObjectId,
                                projectObject: tempModelData,
                              },
                            stateName: SELECTED_CHECKLIST,
                          })
                        );
                        }}>
                        <option value="">Select a Tag</option>
                        {modelData
                          .filter((o) => o.tag != null && o.tag !== "")
                          .map((prop, index) => {
                            return <option value={prop.tag}>{prop.tag}</option>;
                          })}
                      </select> */}
                    </div>
                  </div>
                </>
              )
            }
            {selectedChecklist?.dataLinks?.length > 0 && (
              <>
                <div className="mt-2 d-flex justify-content-center">
                  <div className="col-8 ms-2">
                    <div className="me-auto">
                      {selectedChecklist?.dataLinks?.map((o) => {
                        return (
                          <button
                            className={
                              "btn btn-sm " +
                              (selectedChecklistDataLink == o
                                ? " mwh-btn-primary "
                                : " btn-primary ")
                            }
                            onClick={() => {
                              setSelectedChecklistDataLink(o);
                            }}
                          >
                            {/* {modelData?.find((m) => m.projectObjectId == o.projectObjectId)?.tag} */}
                            {o?.projectObject?.tag}
                          </button>
                        );
                      })}
                    </div>
                  </div>
                </div>
                <div className="d-flex justify-content-center mt-2">
                  <div
                    className="col-12 col-lg-8 p-2"
                    style={{ maxHeight: "500px", overflow: "auto" }}
                  >
                    <table className="table table-hover p-1">
                      <thead>
                        <tr>
                          <th scope="col">Property</th>
                          <th scope="col">Value</th>
                        </tr>
                      </thead>
                      <tbody className="table-light">
                        {modelData
                          ?.find(
                            (o) =>
                              o.projectObjectId ==
                              selectedChecklistDataLink?.projectObjectId,
                          )
                          ?.properties?.filter(
                            (o) =>
                              o.objectProperty == null ||
                              ((o.objectProperty.origin === "Static" ||
                                o.objectProperty.origin === "3D") &&
                                o.objectProperty.schedule),
                          )
                          .sort((a, b) => (a.tag > b.tag ? 1 : -1))
                          .map((prop, index) => {
                            return (
                              <>
                                {prop.objectProperty && (
                                  <tr key={index}>
                                    <td>{prop.objectProperty.property}</td>
                                    <td>{prop.objectProperty.value}</td>
                                  </tr>
                                )}
                                {prop.objectProperty == null && (
                                  <tr key={index}>
                                    <td>{prop.displayName}</td>
                                    <td>{prop.displayValue}</td>
                                  </tr>
                                )}
                              </>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </>
            )}
            <h3>{selectedChecklist.name}</h3>
            <div>
              <CustomFormRenderComp
                key={selectedChecklist?.id}
                form={selectedChecklist}
                editMode={false}
                viewMode={selectedChecklist.status === "Complete"}
              ></CustomFormRenderComp>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default Checklists;
